import { useMemo } from 'react'

import isEmpty from 'lodash-es/isEmpty'

import { ProjectRole } from '@infura/packages.teams'

import { useAllProjects } from 'hooks/useAllProjects'

export default function useProjectRoles(): Record<string, ProjectRole> {
  const { projects = { eth2: [], ethereum: [], ipfs: [] } } = useAllProjects()

  const roles = useMemo<Record<string, ProjectRole>>(() => {
    if (isEmpty(projects)) return {}
    const projectRoles = Object.values(projects).reduce((f, projects) => {
      projects.forEach(project => {
        // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
        f[project.id] = project.role
      })
      return f
    }, {})
    return projectRoles
  }, [projects])

  return roles
}
